import {
    Box, CircularProgress, FormControl,
    InputLabel, MenuItem, Select,
    ToggleButton, ToggleButtonGroup,
} from "@mui/material";
import { COLORS, PERIOD_OPTIONS } from "../configs/config";
import React from "react";

export const DashboardFilters = ({
                                     empresas, empresa, setEmpresa,
                                     period, setPeriod,
                                     year, setYear,
                                     loading,
                                     todos = false
                                 }) => {
    const anos = [
        new Date().getFullYear(),
        new Date().getFullYear() - 1,
        new Date().getFullYear() - 2,
    ];

    const selectSx = {
        color: COLORS.tSec,
        bgcolor: COLORS.card,
        ".MuiOutlinedInput-notchedOutline": { borderColor: COLORS.border },
        "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: COLORS.g2 },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: COLORS.g1 },
        ".MuiSvgIcon-root": { color: COLORS.tDim },
    };

    const TODOS = "todos";
    return (
        <Box display="flex" gap={2} alignItems="center" flexWrap="wrap" mb={3}>
            <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel sx={{ color: COLORS.tDim }}>Empresa</InputLabel>
                <Select
                    value={empresa ?? ""}
                    label="Empresa"
                    onChange={(e) => setEmpresa(e.target.value)}
                    disabled={loading}
                    sx={selectSx}
                >
                    {empresas.map((e) => (
                        <MenuItem key={e.id} value={e.id}>
                            {e.nomeFantasia ?? e.nome}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>



            <ToggleButtonGroup
                value={period ?? TODOS}
                exclusive
                onChange={(_, v) => {
                    if (v === null) return;           
                    setPeriod(v === TODOS ? null : v);  
                }}
                size="small"
                sx={{
                    bgcolor: COLORS.card,
                    border: `0.5px solid ${COLORS.border}`,
                    borderRadius: "8px",
                    ".MuiToggleButton-root": {
                        color: COLORS.tDim,
                        borderColor: COLORS.border,
                        fontSize: 12,
                        px: 1.5,
                        py: 0.5,
                        "&.Mui-selected": {
                            color: "#FFFFFF",
                            bgcolor: COLORS.g1,
                            borderColor: COLORS.g1,
                            "&:hover": { bgcolor: COLORS.g2 },
                        },
                        "&:hover": { bgcolor: COLORS.kpiBg },
                    },
                }}
            >
                {PERIOD_OPTIONS.map((o) => (
                    <ToggleButton key={o.value} value={o.value}>
                        {o.label}
                    </ToggleButton>
                ))}
                {todos && (
                    <ToggleButton key={TODOS} value={TODOS}>
                        Todos
                    </ToggleButton>
                )}
            </ToggleButtonGroup>

            <FormControl size="small" sx={{ minWidth: 100 }}>
                <InputLabel sx={{ color: COLORS.tDim }}>Ano</InputLabel>
                <Select
                    value={year}
                    label="Ano"
                    onChange={(e) => setYear(e.target.value)}
                    disabled={loading || period == null}
                    sx={selectSx}
                >
                    {anos.map((a) => (
                        <MenuItem key={a} value={a}>{a}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            {loading && <CircularProgress size={20} sx={{ color: COLORS.g1 }} />}
        </Box>
    );
};